import React from 'react';
import { motion } from 'framer-motion';
import { RefreshCw, AlertCircle } from 'lucide-react';

interface Props {
  loading: boolean;
  error: string | null;
  onRefresh: () => void;
  children: React.ReactNode;
}

const ZonesStates: React.FC<Props> = ({ loading, error, onRefresh, children }) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4" />
        <p className="text-slate-600 dark:text-slate-400">Loading DNS zones...</p>
      </div>
    );
  }

  if (error) {
    return (
      <motion.div
        className="card text-center py-16"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
          <AlertCircle className="w-8 h-8 text-red-600 dark:text-red-400" />
        </div>
        <h3 className="text-heading-1 text-slate-900 dark:text-white mb-3">
          Failed to load DNS zones
        </h3>
        <p className="text-body text-slate-600 dark:text-slate-400 mb-6 max-w-md mx-auto">
          {error}
        </p>
        <motion.button
          onClick={onRefresh}
          className="inline-flex items-center justify-center px-4 py-2 text-white bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 font-medium rounded-lg transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Try Again
        </motion.button>
      </motion.div>
    );
  }

  return <>{children}</>;
};

export default ZonesStates;